import * as React from 'react';

import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';

import type {EditionFragment as Edition} from 'nutshell-graphql-types';

type Props = {
    edition: Edition;
    styles?: any;
    selectedVersionId: string;
    onChange: (value: any) => void;
};

export function EditionVersionPicker({edition, styles, ...props}: Props) {
    const versionOptions = [
        {
            value: edition.id,
            label: 'Version A',
        },
        {
            value: edition.comparisonEdition && edition.comparisonEdition.id,
            label: 'Version B',
        },
    ];

    return (
        <SelectPickerGeneric
            options={versionOptions}
            value={versionOptions.find((option) => option.value === props.selectedVersionId)}
            onChange={props.onChange}
            styles={{
                // @ts-expect-error
                container: (base) => ({
                    ...base,
                    width: 161,
                    height: 31,
                    ...styles,
                }),
            }}
        />
    );
}
